module.exports = __webpack_public_path__ + "static/img/introduceBTypeBIcon7.55f5272.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/introduceBTypeBIcon7.png
// module id = vyzG
// module chunks = 0